// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/modules/labels-view/labels-view.less
// module id = 3706
// module chunks = 0